( function( $ ) {

	
$(document).ready(function(){

 $(".booster-accord").hide(); // Start with content hidden
  
  $(".booster-dropper").on("click", function(e) {
     e.preventDefault();
    var v = $(this).attr('data-id');
    var m = '#'+v;
    $(".booster-accord").not(m).slideUp();
    $(".booster-dropper").not(this).removeClass('active');
    $(this).addClass('active');
    // Toggle clicked one
    $(m).stop(true, true).slideToggle();
  });


  
$(window).on('load', function() {
    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(window.location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    var emailParam = getUrlParameter('email');
    var statusParam = getUrlParameter('status');

    if (emailParam) {
        var $emailInput = $('input[name="email"], input[type="email"]');
        if ($emailInput.length) {
            $emailInput.val(emailParam);
        } else {
            console.log("Email input not found.");
        }
    } else if (statusParam) {
        $('#thankyou-btn').trigger('click');
      
       $('body').addClass('dove');
    } else {
        window.location.href = "https://ruffgreens.com";
    }
});

  
$(document).on('click', '.booster-selector', function(e) {
    e.preventDefault();

    // Get booster value (normalize spaces)
    var boosterValue = $(this).attr('id').replace(/-/g, ' ');

    // Select matching radio button
    $('input[type="radio"]').prop('checked', false);
    $('input[type="radio"][value="' + boosterValue + '"]').prop('checked', true).trigger('change');

    // Add selected class to booster selector
    $('.booster-selector').removeClass('selected');
    $(this).addClass('selected');

    // Enable the booster-choice link
    $('.booster-choice').removeClass('disabled');
});

$(document).on('click', '#booster_choice', function(e) {
    e.preventDefault();

    // Only trigger if enabled
    if (!$(this).hasClass('disabled')) {
        $('button.btn').trigger('click');
    }
});

// Image navigation
$(document).on('click', '.image-next, .image-prev', function () {
    var $container = $(this).closest('.booster-image');
    var $images = $container.find('img');
    var $current = $images.filter('.active');
    var index = $images.index($current);

    if ($(this).hasClass('image-next')) {
        index = (index + 1) % $images.length;
    } else {
        index = (index - 1 + $images.length) % $images.length;
    }

    $images.removeClass('active').eq(index).addClass('active');
});

// Zoom on second image
$(document).on('click', '.booster-image img.zoomable', function () {
    if ($(this).hasClass('active')) {
        $('#zoomImg').attr('src', $(this).attr('src'));
        $('#zoomModal').fadeIn();
    }
});

// Close zoom modal
$(document).on('click', '.zoom-close, #zoomModal', function () {
    $('#zoomModal').fadeOut();
});


// Open modal
$(document).on('click', '.view-more-btn', function() {
    var modalId = $(this).data('modal');
    $('#' + modalId).fadeIn();
});

// Close modal
$(document).on('click', '.modal-close, .modal-wrapper', function(e) {
    if ($(e.target).is('.modal-close') || $(e.target).is('.modal-wrapper')) {
        $(this).closest('.view-more-modal').fadeOut();
    }
});


  
  
});
} )( jQuery );